export const daySelector_style = {};
